import {gql, useQuery} from '@apollo/client'
import {useSelector} from 'react-redux'
import {useStatesAndHealthConditions} from '../../../../../store/hooks/breadCrumbs'
import {selectFilterDetailsLoading} from '../../../../../store/slices/breadCrumbsSlice'
import {getState} from '../../../../../shared/helpers/getState'
import {useFilterManagement} from '../../../../../store/hooks/useFilterManagement'
import {shouldSkipQuery} from '../helpers'

// This query fetches congressional district data based on the selected filters and benefits for persona as well
const congressionalDistrictQuery = gql`
  query congressionalDistrict($filters: Filters, $benefits: [BenefitEligibility]) {
    congressionalDistrict(filters: $filters, benefits: $benefits) {
      congressionalDistrict {
        state
        congressional_district
        congressional_district_id
        count
        population
        snapEnrolled
        usdaSnapIndCount
        enrolled
        notEnrolled
        usdaSnapIndNotEnrolled
        congressionalDistrictPopulation
        congressionalDistrictPercentage
        statePercentage
        congressionalSnapEnrolledPercentage
        congressionalSnapNotEnrolledPercentage
      }
      missingGeoIds
    }
  }
`

export default function useCongressionalDistrict() {
  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const {filters} = useStatesAndHealthConditions()
  const filterDetailsLoading = useSelector(selectFilterDetailsLoading)

  const appliedFilterParams = getQueryParams()
  const currentStateFromContext = filters && getState(filters)

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  const {
    data: congressionalDistrictData,
    loading: loadingCongressionalDistrict,
    refetch: refetchCongressionalDistrict,
    error: errorLoadingCongressionalDistrict
  } = useQuery(congressionalDistrictQuery, {
    variables: {
      filters: {
        ...appliedFilterParams,
        state: currentStateFromContext
      },
      benefits: benefitsData
    },
    skip: shouldSkipQuery(filterDetailsLoading, currentStateFromContext),
    partialRefetch: true,
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {
    congressionalDistrictData,
    loadingCongressionalDistrict,
    refetchCongressionalDistrict,
    errorLoadingCongressionalDistrict
  }
}
